<template>
  <div class="details_wrap centerWidth" id="mainChild" >
    <div class="tag_position d-flex d-align-center" v-if="type == 1">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <a href="/announcement">通知公告</a>&gt; <span>详情</span>
    </div>
    <div class="tag_position d-flex d-align-center" v-if="type == 2">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <a href="/policyNews">政策新闻</a>&gt; <span>详情</span>
    </div>
    <div class="tag_position d-flex d-align-center" v-if="type == 3">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <a href="/publicCourses">公开课程</a>&gt; <span>详情</span>
    </div>
    <div class="details_info">
      <div class="title_wrap">
        <div class="title_top">
          <div class="left_title_wrap">
            <div>
              {{ info.title }}
            </div>
            <div class="title_biaoqian">
              <div v-if="info.author">来源：{{info.author}}</div>
              <div v-if="info.create_time">发布时间：{{ info.create_time.split(' ')[0] }}</div>
              <div>浏览{{ info.click }}次</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_wrap_new">
        <div v-html="info.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
		articleDetail
	} from "@/api/index";
export default {
  name: "announcementDetail",
  data() {
    return {
      id: '',
      type: 1,
      hotList: [],
      info: {}
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.getDetails()
  },
  methods: {
    getDetails() {
      let ajaxData = {
        id: this.id
      }
      articleDetail(ajaxData).then(res => {
        if (res.code == 1) {
          this.info = res.data
        }
      })
    },
    toDetails(item) {
      document.querySelector('#mainChild').scrollIntoView({
        behavior: "smooth", // 定义动画过渡效果， "auto"或 "smooth" 之一。默认为 "auto"
        block: "start", // 定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"
        inline: "nearest" // 定义水平方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "nearest"
      })
      this.orgNoticeId = item.orgNoticeId
      this.getDetails()
    }
  }
}
</script>

<style scoped lang="scss">
.details_wrap {
  margin: 0 auto;
  .details_info{
    margin-top: 30px;

    .title_top {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .left_title_wrap {
      width: 100%;
      border-bottom: 1px solid #EEEEEE;
      padding-bottom: 20px;
    }

    .left_title_wrap > div:nth-child(1) {
      width: 100%;
      font-size: 32px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #051223;
      text-align: center;
    }

    .title_biaoqian {
      display: flex;
      justify-content: center;
      margin-top: 15px;
      font-size: 14px;
      font-family: Arial;
      font-weight: 400;
      color: #666;
    }

    .title_biaoqian > div:nth-child(2) {
      margin: 0 50px;
    }

    .content_wrap{
      margin-top: 20px;
	  margin-bottom: 50px;
    }
  }
}
</style>
